import { apiClient } from '@app/api';
import { useActiveStation } from '@app/core/stations/hooks/useActiveStation';
import { useMemo } from 'react';
import { useStreamSegmentsRange } from '../../../hooks/segments/useStreamSegmentsQuery';

/**
 * Returns the HLS source URL for the logger video player.
 * Uses the current station and stream segments range. Adds 1 ms to the from
 * timestamp so the API does not return the previous segment.
 */
export function useLoggerVideoSrc() {
  const station = useActiveStation();
  const range = useStreamSegmentsRange()!;

  return useMemo(
    () =>
      apiClient.generateUrl(
        `/segments/stations/${station.id}/hls?from=${range.from + 1}&to=${range.to}`,
        { secure: true },
      ),
    [station.id, range.from, range.to],
  );
}
